import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { CalendarClock, Check, X } from "lucide-react";

const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const addDays = (iso, days) => {
  const [y, m, d] = (iso || todayLocal()).split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
};
const fmtDate = (iso) => { const [y, m, d] = String(iso).slice(0, 10).split("-"); return `${d}.${m}.${y}`; };

export function PaymentTermsSuggestion({ companyId, customerId, issueDate, dueDate, note, onApply, onClearNote }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!companyId || !customerId) { setData(null); return; }
    let ignore = false;
    apiClient.get(`/companies/${companyId}/customers/${customerId}/payment-terms-suggestion`).then((r) => { if (!ignore) setData(r.data); }).catch(() => { if (!ignore) setData(null); });
    return () => { ignore = true; };
  }, [companyId, customerId]);

  const sug = data?.suggestion;
  if (!sug || sug.mode === "default") {
    return note ? <AppliedNote note={note} dueDate={dueDate} onClearNote={onClearNote} /> : null;
  }
  const applied = !!note;
  const tone = data.light === "red" ? "border-rose-200 bg-rose-50/60 text-rose-900" : "border-amber-200 bg-amber-50/60 text-amber-900";
  return (
    <div className={`rounded-md border px-3 py-2 text-xs space-y-1.5 ${tone}`} data-testid="payment-terms-suggestion" data-mode={sug.mode}>
      <div className="flex items-center gap-1.5 font-medium"><CalendarClock className="h-3.5 w-3.5" />Zahlungsfrist-Vorschlag: {sug.reason}</div>
      {applied ? (
        <AppliedNote note={note} dueDate={dueDate} onClearNote={onClearNote} />
      ) : (
        <div className="flex flex-wrap gap-2">
          {sug.mode === "prepayment" && (
            <Button type="button" size="sm" variant="outline" className="h-7 text-xs bg-white" onClick={() => onApply({ due_date: issueDate || todayLocal(), payment_terms_note: sug.note })} data-testid="apply-prepayment-button">
              <Check className="h-3 w-3 mr-1" />Vorauskasse übernehmen
            </Button>
          )}
          {(sug.mode === "short" || sug.alternative_days != null) && (
            <Button type="button" size="sm" variant="outline" className="h-7 text-xs bg-white" onClick={() => { const days = sug.mode === "short" ? sug.days : sug.alternative_days; onApply({ due_date: addDays(issueDate, days), payment_terms_note: `Zahlbar innert ${days} Tagen netto.` }); }} data-testid="apply-short-terms-button">
              <Check className="h-3 w-3 mr-1" />{sug.mode === "short" ? sug.days : sug.alternative_days} Tage statt {data.default_days} übernehmen
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

function AppliedNote({ note, dueDate, onClearNote }) {
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs" data-testid="payment-terms-applied">
      <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-emerald-800"><Check className="h-3 w-3" />{note}{dueDate ? ` · fällig ${fmtDate(dueDate)}` : ""}</span>
      <button type="button" onClick={onClearNote} className="inline-flex items-center gap-0.5 text-slate-500 hover:text-slate-800" data-testid="payment-terms-clear-button"><X className="h-3 w-3" />Entfernen</button>
    </div>
  );
}
